import { companyProfileUrl } from './urls';

export function companyProfileLink(company, isSteward) {
  const companyId = (company && company._id) || company;
  return `${companyProfileUrl}/${companyId}${isSteward ? `?isSteward=true` : ``}`;
}
